import React from 'react'
import classnames from 'classnames'

import Toggle from './Form/toggle'
import PremiumLabel from './Form/PremiumLabel'
import Alert from '../../../util/alert'
import { isPremium } from '../../../../utils/plans'

const SignUpFormSetting = ({reg, website}) => {
  const defaultHeaderText = 'Create Your Free Account'
  const defaultValueText = 'Get instant access to new inventory. Save searches and receive email alerts on new homes, price reductions and status changes'
  const marginStyle = { margin: 20, marginLeft: 40 }
  const formSectionClassnames = classnames('form-section', { disabled: !isPremium(website.plan) })

  return (
    <div className='panel padded'>
      <div className={formSectionClassnames}>
        <label>Sign Up Form <PremiumLabel website={website}/></label>

        <Toggle
          disabled={!isPremium(website.plan)}
          on={reg.social_sign_up_enabled}
          name='social_sign_up_enabled'>
          <strong>
            Social Sign Up / Login Options
          </strong>
        </Toggle>

        <div>
          <p className='muted'>
            Turn off or on the option that allows leads to register or login with Facebook or Google
          </p>

          <Alert
            header='Recommendation'
            description='If you already have leads on your account that may have registered with Facebook or Google, we suggest leaving this setting on'
          />
        </div>
      </div>

      <div className={formSectionClassnames}>
        <label>Sign Up Header Text</label>

        <p className='muted'>
          Change the header text on the sign up form
        </p>

        <div style={marginStyle}>
          <input disabled={!isPremium(website.plan)} defaultValue={reg.sign_up_header_text} name='sign_up_header_text' placeholder={defaultHeaderText} />
        </div>
      </div>

      <div className={formSectionClassnames}>
        <label>Sign Up Value Text</label>

        <p className='muted'>
          Change the text on the sign up form that explains the value of creating an account to leads on the signup form
        </p>

        <div style={marginStyle}>
          <textarea disabled={!isPremium(website.plan)} defaultValue={reg.sign_up_value_text} name='sign_up_value_text' rows='4' placeholder={defaultValueText} />
        </div>
      </div>
    </div>
  )
}

export default SignUpFormSetting



// WEBPACK FOOTER //
// client/components/sections/website/settings/SignUpFormSetting.js